import { Loading } from '@/components/loaders';
import { FC } from 'react';

export const SmsSenderListLoadingState: FC = () => (
  <div className='flex min-h-[240px] items-center justify-center rounded-2xl border border-secondary-border bg-white'>
    <Loading />
  </div>
);
